export default __webpack_public_path__ + "static/media/weekly-tournament-ico.17a1f022.svg";